// MINDSTATE - Sticky ATC behavior
// Show/hide logic + size sync z głównym variant pickerem
(function () {
  'use strict';

  function init() {
    const sticky = document.getElementById('ms-sticky-atc');
    if (!sticky) return;

    const mainAtc = document.querySelector('.template-product add-to-cart-component, .template-product .product-form-buttons');
    const footer = document.querySelector('footer, [class*="site-footer"], [class*="page-footer"]');
    const sizeEl = sticky.querySelector('[data-ms-sticky-size]');
    const btnEl = sticky.querySelector('[data-ms-sticky-btn]');

    // === Show/hide logic ===
    function updateVisibility() {
      if (!mainAtc) return;

      const atcRect = mainAtc.getBoundingClientRect();
      const viewportH = window.innerHeight;

      const atcOutOfView = atcRect.bottom < 0;

      let footerInView = false;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        footerInView = footerRect.top < viewportH * 0.6;
      }

      if (atcOutOfView && !footerInView) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }

    let scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      requestAnimationFrame(function () {
        updateVisibility();
        scrollTicking = false;
      });
      scrollTicking = true;
    });
    window.addEventListener('resize', updateVisibility);

    updateVisibility();

    // === Sync wybranego rozmiaru ===
    function updateSize() {
      const checked = document.querySelector('variant-picker input[type="radio"]:checked');
      if (checked && sizeEl) {
        sizeEl.textContent = checked.value;
      }
    }

    updateSize();

    document.addEventListener('change', function (e) {
      if (e.target.matches('variant-picker input[type="radio"]')) {
        updateSize();
      }
    });

    // === Klik Dodaj - triggeruje główny ATC ===
    if (btnEl) {
      btnEl.addEventListener('click', function () {
        const realBtn = document.querySelector('.template-product add-to-cart-component button, .template-product button[name="add"]');
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        } else {
          const sw = document.querySelector('variant-picker');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
